module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "agent-chat"
    }
  }, [_c('div', {
    staticClass: "chat-header"
  }, [_c('div', {
    staticClass: "header-left"
  }, [_c('h2', [_c('span', {
    staticClass: "status-indicator",
    class: {
      'status-thinking': _vm.isThinking
    }
  }), _vm._v("\n        " + _vm._s(_vm.agentName) + "\n      ")]), _vm._v(" "), (_vm.claimNumber) ? _c('p', {
    staticClass: "claim-context"
  }, [_vm._v("\n        Claim #" + _vm._s(_vm.claimNumber) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('beta-chip', {
    attrs: {
      "color": "#0092AB"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header-actions"
  }, [_c('el-button', {
    staticClass: "clear-button",
    attrs: {
      "type": "text",
      "disabled": _vm.isThinking || _vm.messages.length === 0,
      "title": "Clear conversation and start new session"
    },
    on: {
      "click": _vm.confirmClearConversation
    }
  }, [_vm._v("\n        New Chat\n      ")]), _vm._v(" "), (!_vm.isMobile) ? _c('span', {
    staticClass: "action-icon icon-chevron-down icon-chevron-right chevron-icon",
    on: {
      "click": _vm.onAgentChatClose
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isMobile) ? _c('span', {
    staticClass: "action-icon icon-close",
    on: {
      "click": _vm.onAgentChatClose
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    ref: "messagesContainer",
    staticClass: "messages-container"
  }, [(_vm.messages.length === 0) ? _c('div', {
    staticClass: "welcome-message"
  }, [_c('div', {
    staticClass: "welcome-icon agent-icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.agentIconPath,
      "alt": _vm.agentName,
      "loading": "lazy"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("How can I help you today?")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.welcomeText))]), _vm._v(" "), _c('div', {
    staticClass: "quick-actions"
  }, _vm._l((_vm.quickActions), function(action, idx) {
    return _c('button', {
      key: idx,
      staticClass: "quick-action-btn",
      on: {
        "click": function($event) {
          return _vm.handleQuickAction(action.text)
        }
      }
    }, [_c('span', {
      class: ['action-icon', 'icon-' + action.icon]
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(action.text))])])
  }), 0)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.messages), function(message, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!message.isThinking && !message.isToolExecution),
        expression: "!message.isThinking && !message.isToolExecution"
      }],
      key: index,
      class: ['message', message.role]
    }, [_c('div', {
      staticClass: "message-content",
      class: {
        error: message.isError
      }
    }, [(message.attachedFiles && message.attachedFiles.length) ? _c('div', {
      staticClass: "attached-files-display"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "attached-files-list"
    }, _vm._l((message.attachedFiles), function(fileName, fileIndex) {
      return _c('span', {
        key: fileIndex,
        staticClass: "attached-file-tag"
      }, [_c('i', {
        staticClass: "el-icon-document"
      }), _vm._v("\n              " + _vm._s(fileName) + "\n            ")])
    }), 0)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.parseContent(message.content)), function(segment, segIndex) {
      return [(segment.type === 'card') ? _c('div', {
        key: 'card-' + segIndex,
        class: ['copilot-card', 'card-' + segment.cardType, {
          'card-loading': segment.isStreaming
        }]
      }, [(segment.isStreaming) ? _c('div', {
        staticClass: "card-loading-indicator"
      }, [_c('span', {
        staticClass: "thinking-spinner"
      }), _vm._v(" "), _c('span', [_vm._v("Generating...")])]) : [_c('div', {
        staticClass: "card-content",
        domProps: {
          "innerHTML": _vm._s(_vm.renderMarkdown(segment.content))
        }
      }), _vm._v(" "), (segment.buttons && segment.buttons.length) ? _c('div', {
        staticClass: "card-actions"
      }, _vm._l((segment.buttons), function(btn, btnIndex) {
        return _c('el-button', {
          key: btnIndex,
          attrs: {
            "type": btn.action === 'cancel' ? 'default' : 'primary',
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleCardAction(btn)
            }
          }
        }, [_vm._v("\n                  " + _vm._s(btn.label) + "\n                ")])
      }), 1) : _vm._e()]], 2) : _c('div', {
        key: 'md-' + segIndex,
        staticClass: "markdown-segment",
        domProps: {
          "innerHTML": _vm._s(_vm.renderMarkdown(segment.content))
        }
      })]
    })], 2)])
  }), _vm._v(" "), (_vm.isThinking && !_vm.hasStreamingContent) ? _c('div', {
    staticClass: "tool-status-floating"
  }, [_c('div', {
    staticClass: "tool-status-line"
  }, [_c('span', {
    staticClass: "thinking-spinner"
  }), _vm._v(" "), _c('span', {
    staticClass: "tool-status-verb"
  }, [_vm._v(_vm._s(_vm.currentToolVerb))]), _vm._v(" "), (_vm.currentToolExecution && _vm.currentToolExecution.tools && _vm.currentToolExecution.tools.length) ? _c('button', {
    staticClass: "tool-details-toggle",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toolDetailsExpanded = !_vm.toolDetailsExpanded
      }
    }
  }, [_c('span', {
    class: ['toggle-chevron', 'icon-chevron-down', {
      expanded: _vm.toolDetailsExpanded
    }]
  }), _vm._v(" "), _c('span', {
    staticClass: "tool-count"
  }, [_vm._v(_vm._s(_vm.currentToolExecution.tools.length) + " tool" + _vm._s(_vm.currentToolExecution.tools.length > 1 ? 's' : ''))])]) : _vm._e()]), _vm._v(" "), (_vm.toolDetailsExpanded && _vm.currentToolExecution && _vm.currentToolExecution.tools && _vm.currentToolExecution.tools.length) ? _c('div', {
    staticClass: "tool-details-expanded"
  }, _vm._l((_vm.currentToolExecution.tools), function(tool, idx) {
    return _c('span', {
      key: idx,
      staticClass: "tool-name-small"
    }, [_vm._v("\n          " + _vm._s(_vm.formatToolName(tool)) + "\n        ")])
  }), 0) : _vm._e()]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "input-area"
  }, [(_vm.selectedFiles.length > 0) ? _c('div', {
    staticClass: "file-preview-container"
  }, _vm._l((_vm.selectedFiles), function(file, index) {
    return _c('div', {
      key: index,
      staticClass: "file-preview-chip"
    }, [_c('i', {
      staticClass: "file-icon",
      class: _vm.getFileIcon(file)
    }), _vm._v(" "), _c('span', {
      staticClass: "file-name"
    }, [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('span', {
      staticClass: "file-size"
    }, [_vm._v("(" + _vm._s(_vm.formatFileSize(file.size)) + ")")]), _vm._v(" "), _c('button', {
      staticClass: "remove-file-btn",
      attrs: {
        "type": "button",
        "disabled": _vm.isThinking
      },
      on: {
        "click": function($event) {
          return _vm.removeFile(index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-close"
    })])])
  }), 0) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": _vm.agentConfig.acceptedFileTypes,
      "multiple": ""
    },
    on: {
      "change": _vm.handleFileSelect
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-row"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "autosize": {
        minRows: 1,
        maxRows: 4
      },
      "placeholder": "Type your message...",
      "disabled": _vm.isThinking,
      "resize": "none"
    },
    nativeOn: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleEnterKey.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.userInput),
      callback: function($$v) {
        _vm.userInput = $$v
      },
      expression: "userInput"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "buttons-column"
  }, [_c('div', {
    staticClass: "icon-buttons"
  }, [_c('button', {
    staticClass: "attach-button",
    attrs: {
      "type": "button",
      "disabled": _vm.isThinking,
      "title": "Attach files"
    },
    on: {
      "click": _vm.triggerFileInput
    }
  }, [_c('span', {
    staticClass: "icon-paperclip"
  })]), _vm._v(" "), _c('button', {
    staticClass: "voice-button",
    class: {
      'is-recording': _vm.isRecording
    },
    attrs: {
      "type": "button",
      "disabled": _vm.isThinking || !_vm.speechRecognitionSupported,
      "title": _vm.voiceButtonTitle
    },
    on: {
      "click": _vm.toggleVoiceRecording
    }
  }, [_c('span', {
    staticClass: "icon-microphone"
  })])]), _vm._v(" "), _c('el-button', {
    staticClass: "send-button",
    attrs: {
      "type": "primary",
      "icon": _vm.isThinking ? '' : '',
      "disabled": !_vm.allowedToSendMessage,
      "loading": _vm.isThinking
    },
    on: {
      "click": _vm.sendMessage
    }
  }, [(!_vm.isThinking) ? _c('span', [_vm._v("Send")]) : _vm._e()])], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "attached-files-label"
  }, [_c('i', {
    staticClass: "el-icon-paperclip"
  }), _vm._v("\n            Attached files:\n          ")])
}]}